import PropTypes from 'prop-types';

import { Input, PillOverlayPopover } from '@utilities';

import styles from './_index.module.scss';

const NumericLogicInput = ({
  firstErrorRef,
  isError,
  isFocused,
  isRequired,
  question,
  setValue,
  value,
}) => {
  const handleChange = (inputValue) => {
    setValue(inputValue === '' ? '' : parseFloat(inputValue));
  };

  return (
    <PillOverlayPopover
      buttonRef={isFocused ? firstErrorRef : null}
      isError={isError}
      isRequired={isRequired}
      overlayClassName={styles['numeric-input-overlay']}
      pillClassName={isFocused ? styles['numeric-input-pill-focus'] : null}
      value={value === '' ? 'Numerical Value' : value}
    >
      <Input
        className={styles['numeric-logic-input']}
        error={isError ? 'Please enter a number.' : null}
        id={`numeric-logic-input-${question.id}`}
        label="Enter a number"
        onChange={handleChange}
        placeholder="Numerical Value"
        type="number"
        value={value}
      />
    </PillOverlayPopover>
  );
};

NumericLogicInput.propTypes = {
  buttonRef: PropTypes.object,
  firstErrorRef: PropTypes.object,
  isError: PropTypes.bool,
  isFocused: PropTypes.bool,
  isRequired: PropTypes.bool,
  question: PropTypes.object.isRequired,
  setValue: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default NumericLogicInput;
